import React, { useState } from 'react';
import { useAuth } from './App';
import axios from 'axios';

const CustomerRequestPage = () => {
  const { language } = useAuth();
  const [formData, setFormData] = useState({
    customerName: '',
    phone: '',
    city: '',
    address: '',
    dateOfService: '',
    timeOfService: '',
    servicesNeeded: {},
    maxLeadDays: '3',
    details: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const availableRoles = [
    { id: 'vadhyar', label_en: 'Vadhyar / Purohit', label_ta: 'வாத்தியார் / புரோகிதர்' },
    { id: 'cook', label_en: 'Cook / Thaligai', label_ta: 'சமையல் சுவாமிகள் / தளிகை' },
    { id: 'veda_pandit', label_en: 'Veda Pandit', label_ta: 'வேத பண்டிதர்' },
    { id: 'assistant_male', label_en: 'Vaideeka Assistant (Male)', label_ta: 'வைதீக உதவியாளர் (ஆண்)' },
    { id: 'assistant_female', label_en: 'Catering Assistant (Female)', label_ta: 'சமையல் உதவியாளர் (பெண்)' },
    { id: 'boktha', label_en: 'Male Boktha / Swamigal', label_ta: 'போக்தா / சுவாமிகள் (ஆண்)' },
    { id: 'driver', label_en: 'Driver', label_ta: 'ஓட்டுநர்' },
    { id: 'other', label_en: 'Other Service', label_ta: 'மற்ற சேவைகள்' }
  ];

  const handleRoleChange = (roleId) => {
    setFormData(prev => {
      const servicesNeeded = { ...prev.servicesNeeded };
      if (servicesNeeded[roleId]) {
        delete servicesNeeded[roleId];
      } else {
        servicesNeeded[roleId] = 1;
      }
      return { ...prev, servicesNeeded };
    });
  };

  const handleRoleCountChange = (roleId, count) => {
    setFormData(prev => {
      const servicesNeeded = { ...prev.servicesNeeded };
      if (servicesNeeded[roleId]) {
        servicesNeeded[roleId] = count;
      }
      return { ...prev, servicesNeeded };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.keys(formData.servicesNeeded).length === 0) {
      alert(language === 'en' ? 'Please select at least one service required.' : 'தயவுசெய்து குறைந்தபட்சம் ஒரு சேவையையாவது தேர்ந்தெடுக்கவும்.');
      return;
    }
    setLoading(true);
    try {
      // Stub for future backend integration
      setTimeout(() => {
        setSubmitted(true);
        setLoading(false);
      }, 1000);
    } catch (err) {
      console.error(err);
      alert('Error submitting request');
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-orange-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-2xl text-center border-t-4 border-orange-600">
          <div className="text-6xl mb-4">🙏</div>
          <h2 className="text-3xl font-bold text-orange-800 mb-4">
            {language === 'en' ? 'Request Submitted Successfully!' : 'தங்கள் கோரிக்கை வெற்றிகரமாகப் பதிவு செய்யப்பட்டது!'}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            {language === 'en'
              ? 'Thank you for choosing Ahobilam. We will notify our registered service partners about your requirement. Our team will contact you shortly regarding the Rs. 100/- booking fee payment.'
              : 'அஹோபிலம் சேவையைத் தேர்ந்தெடுத்தமைக்கு நன்றி! உங்கள் தேவைக்கேற்ப எங்களிடம் பதிவு செய்துள்ள பணியாளர்களுக்குத் தகவல் அனுப்புவோம். முன்பதிவுக் கட்டணம் ரூ.100/- செலுத்துவது குறித்து எங்கள் குழு உங்களைத் தொடர்புகொள்ளும்.'}
          </p>
          <button 
            onClick={() => window.location.href = '/'}
            className="bg-orange-600 text-white px-8 py-3 rounded-full hover:bg-orange-700 font-bold transition"
          >
            {language === 'en' ? 'Back to Home' : 'முகப்புப் பக்கத்திற்குச் செல்'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-12 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-5xl font-bold text-blue-800 mb-4 drop-shadow-sm">
            {language === 'en' ? 'Request Vaideeka Personnel' : 'வைதீகப் பணியாளர்கள் தேவை'}
          </h1>
          <p className="text-lg md:text-xl text-gray-700">
            {language === 'en' 
              ? 'Find experienced Vadhyars, Cooks, and Assistants for your religious events' 
              : 'தங்கள் வீட்டு சுபநிகழ்ச்சிகள் மற்றும் வைதீக காரியங்களுக்கு வாத்தியார், சமையல் சுவாமிகள் போன்றவர்களை எளிதாகப் பெறலாம்'}
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-blue-100 border-l-4 border-blue-600 p-6 md:p-8">
            <h3 className="text-xl font-bold text-blue-800 mb-2 flex items-center">
              <span className="text-2xl mr-2">ℹ️</span> 
              {language === 'en' ? 'Booking Rules & Fees (Important)' : 'முன்பதிவு விதிகள் மற்றும் கட்டணம் (முக்கியம்)'}
            </h3>
            <ul className="list-disc pl-8 text-gray-800 space-y-3 mt-4 text-justify">
              {language === 'ta' ? (
                <>
                  <li>பணியாளர்களைத் தேடும் வாடிக்கையாளர்களுக்கு இது இலவச சேவை <strong>அல்ல</strong>. முன்பதிவுக் கட்டணமாக <strong>ரூ. 100/-</strong> செலுத்த வேண்டும்.</li>
                  <li>நீங்கள் கோரிக்கை விடுத்த பிறகு, குறைந்தபட்சம் ஒரு பணியாளரின் (Lead) தகவலாவது உங்களுக்கு அனுப்பி வைக்கப்படும்.</li>
                  <li><strong>கட்டணத்தைத் திரும்பப் பெறுதல்:</strong> நீங்கள் நிர்ணயிக்கும் அதிகபட்ச நாட்களுக்குள் (1 முதல் 7 நாட்கள் வரை) எங்களால் எந்தவொரு பணியாளரையும் பரிந்துரைக்க முடியவில்லை என்றால், உங்கள் ரூ.100/- கட்டணத்தை நீங்கள் திரும்பப் பெற்றுக் கொள்ளலாம்.</li>
                  <li className="text-red-700 font-bold">கவனிக்கவும்: குறைந்தபட்சம் ஒரு பணியாளரின் தகவலை நாங்கள் உங்களுக்கு அனுப்பிவிட்டாலும், அதன்பிறகு பதிவுக்கட்டணத்தைத் திரும்பப் பெற முடியாது. பணியாளரின் சம்பளம் மற்றும் இதர ஒப்பந்தங்களை நீங்களே நேரடியாகப் பேசிக்கொள்ள வேண்டும்.</li>
                </>
              ) : (
                <>
                  <li>This is <strong>NOT</strong> a free service. Customers expecting personnel must pay a booking fee of <strong>Rs. 100/- per booking</strong>.</li>
                  <li>After booking, we will notify our registered personnel and provide you with at least one lead (contact of an interested person).</li>
                  <li><strong>Refund Policy:</strong> You can set a maximum wait time (1 to 7 days). If we are unable to send even a single lead within your specified timeframe, you can withdraw/refund your Rs. 100/- fee.</li>
                  <li className="text-red-700 font-bold">Note: Once at least one lead is sent to you, the booking fee cannot be refunded. You can negotiate the actual service fees directly with the personnel.</li>
                </>
              )}
            </ul>
          </div>

          <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-6">
            
            {/* What do you need? */}
            <div>
              <label className="block text-blue-900 text-xl font-bold mb-4 border-b-2 border-blue-100 pb-2">
                {language === 'en' ? '1. Who do you need?' : '1. உங்களுக்கு யார் தேவை?'} *
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {availableRoles.map(role => (
                  <div key={role.id} className={`flex flex-col p-4 border-2 rounded-xl transition-all ${formData.servicesNeeded[role.id] ? 'bg-blue-50 border-blue-500 shadow-sm' : 'hover:bg-gray-50 border-gray-200'}`}>
                    <label className="flex items-center cursor-pointer mb-2">
                      <input
                        type="checkbox"
                        checked={!!formData.servicesNeeded[role.id]}
                        onChange={() => handleRoleChange(role.id)}
                        className="w-5 h-5 text-blue-600 rounded mr-3 focus:ring-blue-500"
                      />
                      <span className="font-semibold text-gray-800">
                        {language === 'en' ? role.label_en : role.label_ta}
                      </span>
                    </label>
                    {!!formData.servicesNeeded[role.id] && (
                      <div className="ml-8 flex items-center">
                        <span className="text-sm text-gray-600 mr-2">{language === 'en' ? 'No. of Persons:' : 'எத்தனை நபர்கள்:'}</span>
                        <input 
                          type="number" 
                          min="1" 
                          value={formData.servicesNeeded[role.id]} 
                          onChange={(e) => handleRoleCountChange(role.id, parseInt(e.target.value) || 1)}
                          className="w-20 px-2 py-1 border rounded border-gray-300 focus:ring-blue-500"
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* When do you need them? */}
            <div className="pt-6">
              <label className="block text-blue-900 text-xl font-bold mb-4 border-b-2 border-blue-100 pb-2">
                {language === 'en' ? '2. When do you need them?' : '2. எந்தத் தேதிக்குத் தேவை?'}
              </label>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Date of Event' : 'நிகழ்ச்சியின் தேதி'} *
                  </label>
                  <input
                    type="date"
                    required
                    value={formData.dateOfService}
                    onChange={e => setFormData({...formData, dateOfService: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Time of Service' : 'நேரம் (உத்தேசமாக)'} *
                  </label>
                  <input
                    type="time"
                    required
                    value={formData.timeOfService}
                    onChange={e => setFormData({...formData, timeOfService: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Max wait days for lead' : 'பதிலுக்காக காத்திருக்கும் நாட்கள்'} *
                  </label>
                  <select
                    required
                    value={formData.maxLeadDays}
                    onChange={e => setFormData({...formData, maxLeadDays: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none bg-white"
                  >
                    {[1,2,3,4,5,6,7].map(day => (
                        <option key={day} value={day}>{day} {language === 'en' ? (day === 1 ? 'Day' : 'Days') : 'நாட்கள்'}</option>
                    ))}
                  </select>
                </div>
              </div>
              <p className="text-sm text-gray-500 mt-2">
                {language === 'en' ? '* If we cannot find a person within these days, your Rs.100 will be refundable.' : '* இந்த நாட்களுக்குள் எங்களால் ஆள் தரமுடியாவிட்டால், உங்கள் ரூ.100 கட்டணத்தை நீங்கள் திரும்பப் பெறலாம்.'}
              </p>
            </div>

            {/* Where and Contact info */}
            <div className="pt-6">
              <label className="block text-blue-900 text-xl font-bold mb-4 border-b-2 border-blue-100 pb-2">
                {language === 'en' ? '3. Contact & Location Details' : '3. தொடர்பு மற்றும் முகவரி'}
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Your Name' : 'தங்கள் பெயர்'} *
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.customerName}
                    onChange={e => setFormData({...formData, customerName: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder={language === 'en' ? 'Enter your name' : 'உங்கள் பெயர்'}
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'Phone Number' : 'தொடர்பு எண்'} *
                  </label>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={e => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="10 digit number"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-bold mb-2">
                    {language === 'en' ? 'City' : 'நகரம்'} *
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.city}
                    onChange={e => setFormData({...formData, city: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    placeholder="e.g. Chennai"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-gray-700 font-bold mb-2">
                  {language === 'en' ? 'Detailed Address & Event Info' : 'முழு முகவரி மற்றும் நிகழ்ச்சியின் சிறு குறிப்பு'} *
                </label>
                <textarea
                  required
                  rows="3"
                  value={formData.address}
                  onChange={e => setFormData({...formData, address: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder={language === 'en' ? 'Full address and what the event is about (e.g. Ayush Homam)' : 'முகவரி மற்றும் என்ன விசேஷம் (உ-ம்: ஆயுஷ்ய ஹோமம்) என்று குறிப்பிடவும்'}
                />
              </div>
            </div>

            <div className="bg-blue-50 p-4 rounded-lg mt-6 border border-blue-200">
                <label className="flex items-start cursor-pointer group">
                    <input type="checkbox" required className="mt-1 w-5 h-5 text-blue-600 rounded mr-3" />
                    <span className="text-gray-800 text-sm font-medium">
                        {language === 'en' ? 'I agree to pay the Rs. 100/- booking fee. I understand it is non-refundable once a lead is sent.' : 'நான் ரூ. 100/- முன்பதிவுக் கட்டணம் செலுத்தச் சம்மதிக்கிறேன். எனக்கு ஒரு பணியாளரின் விபரம் அனுப்பப்பட்ட பிறகு இக்கட்டணத்தைத் திரும்பப் பெற முடியாது என்பதைப் புரிந்துகொண்டேன்.'}
                    </span>
                </label>
            </div>

            <button
              type="submit"
              disabled={loading || Object.keys(formData.servicesNeeded).length === 0}
              className="w-full bg-blue-600 text-white py-4 rounded-xl hover:bg-blue-700 font-bold text-xl disabled:bg-gray-400 disabled:cursor-not-allowed transition shadow-lg mt-4"
            >
              {loading 
                ? (language === 'en' ? 'Submitting...' : 'சமர்ப்பிக்கப்படுகிறது...') 
                : (language === 'en' ? 'Agree & Submit Request' : 'சம்மதித்து கோரிக்கையைச் சமர்ப்பி')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CustomerRequestPage;
